/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react'
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined'
import { colors } from '@resiliatech/birdsong'
import moment from 'moment'
import { DatePicker } from '../../../../../SharedComponents/DatePicker/DatePicker'
import {
  ISO_8601_DATE_FORMAT,
  TASK_DATE_FORMAT,
} from '../../../ImpactReportDashboard/utils'
import { OnUpdateOptions } from '../types'
import { dateInputStyles } from './TaskModalV2.styled'

type DueDateInputProps = {
  dueDate: string | null | undefined
  onUpdateOptions: OnUpdateOptions
}

const inputStyles = {
  ...dateInputStyles,
  '.MuiFormLabel-root': {
    '&.Mui-error': {
      color: 'rgba(0, 0, 0, 0.87)', // Default label color
    },
  },
  // Overriding error styles
  '& .MuiOutlinedInput-root': {
    '&.Mui-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.23)', // Default border color
      },
    },
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: 'rgba(0, 0, 0, 0.6)', // Default helper text color
  },
}

export const DueDateInput = ({
  dueDate,
  onUpdateOptions,
}: DueDateInputProps) => (
  <DatePicker
    date={
      dueDate
        ? moment.utc(dueDate, ISO_8601_DATE_FORMAT).format(TASK_DATE_FORMAT)
        : null
    }
    label='Due Date'
    onDateSelected={(date) =>
      onUpdateOptions({
        key: 'dueDate',
        value: moment.utc(date).format(TASK_DATE_FORMAT),
      })
    }
    props={{
      slots: { openPickerIcon: InsertInvitationOutlinedIcon },
    }}
    slotProps={{
      openPickerIcon: { sx: { color: colors.interactive.primaryEnabled } },
    }}
    styles={inputStyles}
  />
)
